export default {
      id: "icon-arrow-left-usage",
      viewBox: "0 0 15 12",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#icon-arrow-left",
      toString: function () {
        return this.url;
      }
    }